import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const About = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet prioritizeSeoTags={true}>
  <meta httpEquiv="content-type" content="text/html; charset=utf-8" />
  <meta name="format-detection" content="telephone=no" />
  <title>Know More About Codezix : Leading Salesforce Partner</title>
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <meta name="keywords" content=" " />
  <meta
    name="description"
    content="Want to know more about Codezix ? Codezix is US based Salesforce consulting agency specialised in providing Salesforce solutions"
  />

  {/* BreadcrumbList */}
  <script type="application/ld+json">
    {`
{
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://codezix.com/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "About Us",
      "item": "https://codezix.com/about"
    }
  ]
}
    `}
  </script>

  {/* Organization */}
  <script type="application/ld+json">
    {`
{
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://codezix.com/#organization",
  "name": "Codezix",
  "legalName": "Codezix Solutions",
  "url": "https://codezix.com/",
  "logo": "https://codezix.com/assets/images/logo.webp",
  "description": "Codezix is a global Salesforce, cloud consulting, and custom application development company helping organizations innovate faster.",
  "email": "info@codezix.com",
  "telephone": "+1-917-730-7436",
  "sameAs": [
    "https://www.linkedin.com/company/codezix",
    "https://www.facebook.com/codezix",
    "https://twitter.com/codezix"
  ]
}
    `}
  </script>

  {/* WebSite */}
  <script type="application/ld+json">
    {`
{
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "https://codezix.com/#website",
  "url": "https://codezix.com/",
  "name": "Codezix",
  "publisher": {
    "@id": "https://codezix.com/#organization"
  }
}
    `}
  </script>

  {/* AboutPage */}
  <script type="application/ld+json">
    {`
{
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "@id": "https://codezix.com/about#aboutpage",
  "url": "https://codezix.com/about",
  "name": "About Codezix",
  "description": "Want to know more about Codezix? Codezix is a US-based Salesforce consulting agency specialized in providing Salesforce solutions.",
  "inLanguage": "en-US",
  "isPartOf": {
    "@id": "https://codezix.com/#website"
  },
  "about": {
    "@id": "https://codezix.com/#organization"
  }
}
    `}
  </script>
</Helmet>



            <section className="about-banner-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 top">
                            <div className="inner-banner-content">
                                <h1 className="wow fadeUp">About Codezix</h1>
                                <p className="wow fadeIn prose-lg text-white ml-1">We’re not just Salesforce CRM experts. At Codezix, we've built a team and a culture that provides each and every client with the support they need to achieve their business goals.</p>
                                <div className="consulting-button">
                                    <Link to="/contact"><button>Schedule A Call With Experts <i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6"></div>
                    </div>
                </div>
            </section>

            <div className="about-information exp-about top_padding bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Let's Our Number Speak</h2>
                    </div>
                    <div className="row mt-4">
                        <div className="col-lg-3 col-md-6">
                            <div className="number-speak">
                                <h3>200+</h3>
                                <p>Projects Delivered</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="number-speak">
                                <h3>7 Apps</h3>
                                <p>Salesforce App Exchange</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="number-speak">
                                <h3>45+</h3>
                                <p>Clients Served Worldwide</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="number-speak">
                                <h3>80+</h3>
                                <p>Certified Developers</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-information award_about bottom top_padding">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Award-Winning</h2>
                        <h2>alesforce Consulting Company</h2>
                        <p className="wow fadeIn prose-lg">A Testament to Our Achievements Marked with Honour and Excellence</p>
                    </div>
                    <div className="row">
                        <div class="awards">
                            <div class="hic-award d-flex align-items-center justify-content-md-start justify-content-center flex-wrap flex-lg-nowrap">
                                <div class="award-items">
                                    <img src={require('../assets/images/award/part-1.webp')} alt="image of _322133" class="wp-post-0 wp-image-61560" />
                                </div>
                                <div class="award-items">
                                    <img src={require('../assets/images/award/part-2.webp')} alt="image of _322133" class="wp-post-0 wp-image-61560" />
                                </div>
                                <div class="award-items">
                                    <img src={require('../assets/images/award/part-3.webp')} alt="image of _322133" class="wp-post-0 wp-image-61560" />
                                </div>
                                <div class="award-items">
                                    <img src={require('../assets/images/award/part-4.webp')} alt="image of _322133" class="wp-post-0 wp-image-61560" />
                                </div>
                                <div class="award-items">
                                    <img src={require('../assets/images/award/part-5.webp')} alt="image of _322133" class="wp-post-0 wp-image-61560" />
                                </div>
                                <div class="award-items">
                                    <img src={require('../assets/images/award/part-6.webp')} alt="image of _322133" class="wp-post-0 wp-image-61560" />
                                </div>
                                <div class="award-items">
                                    <img src={require('../assets/images/award/part-7.webp')} alt="image of _322133" class="wp-post-0 wp-image-61560" />
                                </div>
                                <div class="award-items">
                                    <img src={require('../assets/images/award/part-8.webp')} alt="image of _322133" class="wp-post-0 wp-image-61560" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="vision-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="vision-left mt-4">
                                <div className="vision-inner">
                                    <img src={require('../assets/images/about/our-vision-icon.webp')} alt="" />
                                    <span className="mt-4">Our Vision</span>
                                </div>
                                <p className="wow fadeUp prose-lg">Codezix foundation is built on one belief: “Putting Our People First” because it's their hard work and brilliance that fuel our success. With a vision to revolutionize industries and empower businesses, we strive to innovate, collaborate, and redefine possibilities across industries.</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="vision-right">
                                <img src={require('../assets/images/about/vision-team.webp')} alt="" />
                            </div>
                        </div>
                    </div>

                    <div className="row top_padding">
                        <div className="col-lg-6">
                            <div className="vision-left mt-4">
                                <div className="vision-inner">
                                    <img src={require('../assets/images/about/our-mission-icon.webp')} alt="" />
                                    <span className="mt-4">Our Mission</span>
                                </div>
                                <p className="wow fadeUp prose-lg">At Codezix, we empower business leaders by offering innovative technology solutions designed to drive sustainable growth, efficiency, and competitiveness. Our team is dedicated to delivering exceptional solutions to our clients, ensuring timely and effective results.</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="vision-right">
                                <img src={require('../assets/images/about/mision-team.webp')} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='services-our-section'>
                <div className='container'>
                    <div className="row1">
                        <div className="col-md-4">
                            <h2 className='services-heading-bar'>
                                End-to-End<br />Salesforce Solutions
                            </h2>
                            <div>
                                <div className='implementation-button'>
                                    <div className="inner-about-button">
                                        <Link to="/contact"><button>Consult With Experts <i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <br />
                        </div>

                        <div className="col-md-4">
                            <div className='services-item'>
                                <Link to="/development">
                                    <div className="serviceCard newColor">
                                        <span className="servicon">
                                            <img
                                                src={require('../assets/images/our-services/development.webp')}
                                                alt="salesforce development"
                                            />
                                            <br />
                                        </span>
                                        <h3>Salesforce Development</h3>
                                        <p>
                                            Salesforce development creates solutions by combining no-code technologies with code. The proper tools
                                            for the job. This is referred to as low-code development.
                                        </p>
                                        <br />
                                        <Link
                                            to="/development"
                                            className="arrowBtn"
                                        >
                                            <span>
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </span>
                                        </Link>
                                    </div>
                                </Link>
                            </div>
                        </div>

                        {/* Salesforce Integration Card */}
                        <div className="col-md-4">
                            <div className='services-item'>
                                <Link to="/integration">
                                    <div className="serviceCard">
                                        <span className="servicon">
                                            <img
                                                src={require('../assets/images/our-services/api.webp')}
                                                alt="salesforce integration"
                                            />
                                            <br />
                                        </span>
                                        <h3>Salesforce Integration</h3>
                                        <p>
                                            Salesforce integration is a CRM software that links businesses and their customers. Unified integrated
                                            CRM platform that provides a complete image of each customer.
                                        </p>
                                        <br />
                                        <Link
                                            to="/integration"
                                            className="arrowBtn"
                                        >
                                            <span>
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </span>
                                        </Link>
                                    </div>
                                </Link>
                            </div>
                        </div>

                        {/* Salesforce Consulting Card */}
                        <div className="col-md-4">
                            <div className='services-item'>
                                <Link to="/consulting">
                                    <div className="serviceCard newColor">
                                        <span className="servicon">
                                            <img
                                                src={require('../assets/images/our-services/consulting.webp')}
                                                alt="salesforce consulting"
                                            />
                                            <br />
                                        </span>
                                        <h3>Salesforce Consulting</h3>
                                        <p>
                                            Salesforce consultants are important resources for any organization since they increase their worth by
                                            producing more income fostering goodwill among their clients.
                                        </p>
                                        <br />
                                        <Link
                                            to="/consulting"
                                            className="arrowBtn"
                                        >
                                            <span>
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </span>
                                        </Link>
                                    </div>
                                </Link>
                            </div>
                        </div>

                        {/* Salesforce Staff Augmentation Card */}
                        <div className="col-md-4">
                            <div className='services-item'>
                                <Link to="/">
                                    <div className="serviceCard">
                                        <span className="servicon">
                                            <img
                                                src={require('../assets/images/our-services/staff-augmentation.webp')}
                                                alt="salesforce staff augmentation"
                                            />
                                            <br />
                                        </span>
                                        <h3>Staff Augmentation</h3>
                                        <p>
                                            Staff augmentation enables organizations to increase the capacity of their teams by bringing in committed
                                            technical experts who work extension existing team.
                                        </p>
                                        <br />
                                        <Link
                                            to="/about#"
                                            className="arrowBtn"
                                        >
                                            <span>
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </span>
                                        </Link>
                                    </div>
                                </Link>
                            </div>
                        </div>

                        {/* Salesforce Support Card */}
                        <div className="col-md-4">
                            <div className='services-item'>
                                <Link to="/salesforce/support">
                                    <div className="serviceCard newColor">
                                        <span className="servicon">
                                            <img
                                                src={require('../assets/images/our-services/support.webp')}
                                                alt="salesforce support"
                                            />
                                            <br />
                                        </span>
                                        <h3>Salesforce Support</h3>
                                        <p>
                                            Salesforce Support is customer relationship management platform designed help Salesforce clients deliver exceptional service and support to their business customers.
                                        </p>
                                        <br />
                                        <Link
                                            to="/salesforce/support"
                                            className="arrowBtn"
                                        >
                                            <span>
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </span>
                                        </Link>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-cover-value bottom top">
                <div className="container">

                    <div className="row mt-4">
                        <div className="col-lg-6">
                            <div className='explore-heading text-left'>
                                <h2>Core Values</h2>
                            </div>
                            <div className="col-value-left">
                                <p className="prose-lg wow fadeUp">
                                    At Codezix, we are driven by passionate and dedicated experts in Salesforce.com and related digital technologies. Our core mission is to go the extra mile in creating customer delight. The values that are most important to every Codezix, and to us as a company, are...                                </p>
                                <div className="startagy">
                                    <img src={require('../assets/images/about/cv-icon1.webp')} alt="" />
                                    <p className="wow fadeUp prose-lg">Uncompromising Integrity</p>
                                </div>
                                <div className="startagy">
                                    <img src={require('../assets/images/about/cv-icon2.webp')} alt="" />
                                    <p className="wow fadeUp prose-lg">Absolute Credibility</p>
                                </div>
                                <div className="startagy">
                                    <img src={require('../assets/images/about/cv-icon3.webp')} alt="" />
                                    <p className="wow fadeUp prose-lg">
                                        Best in Class Innovation</p>
                                </div>
                                <div className="startagy">
                                    <img src={require('../assets/images/about/cv-icon4.webp')} alt="" />
                                    <p className="wow fadeUp prose-lg">
                                        Wow Customer Experience</p>
                                </div>
                                <div className="startagy">
                                    <img src={require('../assets/images/about/cv-icon5.webp')} alt="" />
                                    <p className="wow fadeUp prose-lg">
                                        Passion and Courage to Experiment</p>
                                </div>
                                <div className='made-mark-button mt-4 mb-3'>
                                    <div className="inner-about-button">
                                        <Link to="/contact"><button>Get In Touch <i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="col-value-right">
                                <img src={require('../assets/images/about-sales.webp')} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section class="whyChoose mt-4 bottom">
                <div class="container">
                    <div class="headingText">
                        <h2><b>Why <br /> <span>Choose Codezix</span></b></h2>
                        <p className='wow fadeUp prose-lg'>We at Codezix have been providing enormous consulting &amp; services to many businesses as we have over more than 12 years of experience. </p>
                    </div>
                    <div class="row chooseRow">
                        <div className='row'>
                            <div className='col-md-6'>
                                <div class="ChooseList">
                                    <ul>
                                        <li><span><i class="fas fa-check"></i></span>Top Salesforce Consulting & Development.
                                        </li>
                                        <li><span><i class="fas fa-check"></i></span> 30+ certified professionals and consultants.
                                        </li>
                                        <li><span><i class="fas fa-check"></i></span> 50+ Salesforce projects delivered.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div class="ChooseList">
                                    <ul>
                                        <li><span><i class="fas fa-check"></i></span> Fast delivery with high-qualities services.
                                        </li>
                                        <li><span><i class="fas fa-check"></i></span> 100% in-house code.
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="choodeCard">
                                <span><i class="fa fa-check"></i></span>
                                <br />
                                <h3>Our Mission</h3>
                                <p className="prose-lg">Codezix aims to seamlessly integrate client data through a streamlined process, helping both you and your customers to the achieve and your business goals.
                                </p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="choodeCard">
                                <span><i class="fa fa-check"></i></span>
                                <br />
                                <h3>Client-Focused Approach</h3>
                                <p className="prose-lg">Codezix communication prioritization such as customer experiences, interaction, and technology helps you and your customer achieve solution of any problem and convert.
                                </p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="choodeCard">
                                <span><i class="fas fa-check"></i></span>
                                <br />
                                <h3>Our Principles</h3>
                                <p className="prose-lg"> Our desire is to provide greatest solutions to our clients by boosting their company operations use of technology, based on principles rapid delivery, high-quality service.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="about-information bottom">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 order-1">
                            <div className="about-expertise">
                                <img src={require('../assets/images/about-check.webp')} alt="" />
                            </div>
                        </div>
                        <div className="col-lg-8 order-2 top_padding">
                            <div className="exptertise-right">
                                <h3>Sharing our <span>Salesforce Expertise</span> and Passion</h3>
                                <p className="prose-lg">We pride ourselves on our technical, project and business analysis skills which enable us to solve the most complex business requirements. Our experienced team understands how to get the best from Salesforce and we apply that knowledge to ensuring your business can grow from strength to strength with the capabilities offered by Salesforce CRM. Simply tell us what you need and HIC Global Solutions will create and support your use of the right suite of customer relationship management tools, to support your business goals.</p>
                                <div className="consulting-button mt-5">
                                    <Link to="/contact"><button>Schedule A Call With Experts <i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default About;